import actModel from "@/models/act_idtf_assignment";
import articleModel from "@/models/article_idtf_assignment";
import store from "@/store";
import axios from 'axios';
import H_helpers from "@/helpers/helpers";
import Spare_idtf from "@/spare/idtf";

export default{
  getBreadcrumbsItems(modelData, breadcrumbsFields) {
    if (!modelData || !breadcrumbsFields) return;
    const _breadcrumbsItems = [];
    breadcrumbsFields.forEach((item) => {
      _breadcrumbsItems.push({
        text: item.text ? item.text : item.getText(modelData),
        to:
          item.url !== undefined
            ? item.url
            : item.getUrl !== undefined
            ? item.getUrl(modelData)
            : null,
        disabled: item.disabled,
      });
    });
    return _breadcrumbsItems;
  },
  setModelDatas(modelData, type, keys, updateData, subModelName, field) {
    const checkedList = updateData[subModelName];
    const updateDataByType = updateData[type];
    const tabValue = field && field.tab ? field.tab.value : '';
    modelData.forEach((data, dataIndex) => {
      data.currentStage = subModelName;
      if (type === 'act') {
        const updateData = checkedList.find(item => item.act_version !== undefined);
        const _data = data.last_version;
        keys.forEach((key) => {
          data[key] = _data[key] !== undefined
            ? _data[key]
            : _data["act_idtf_assignment"][key] !== undefined
            ? _data["act_idtf_assignment"][key]
            : _data["act_idtf_assignment_item"]
            ? _data["act_idtf_assignment_item"][key] !== undefined
            ? _data["act_idtf_assignment_item"][key]
            : null
            : null;
        });
        data.dot = this.setDot(data, subModelName, updateData);
      } else if (type === 'article') {
        if (!data["act_idtf_assignment_item"]) return;
        const tarIndex = checkedList.findIndex(item => item.article_version !== undefined && item.article_version === data.id);
        const checkData = checkedList[tarIndex];
        const _data = data["act_idtf_assignment_item"];
        keys.forEach((key) => {
          if (data[key] !== undefined) {
            return;
          } else {
            data[key] = _data[key] !== undefined ? _data[key] : null;
          }
        });
        if (tarIndex >= 0) {
          modelData[dataIndex][subModelName] = checkData[subModelName];
        }
        if (updateDataByType !== undefined) {
          const tarIndex = updateDataByType.findIndex(_data => _data.id === data.id);
          if (tarIndex < 0) return;
          const {ll_comment, effects, chapter, content, no_text, official_comment, rich_content, attaches, no_number, reference_link,} = updateDataByType[tarIndex];
          if (subModelName === 'act_cnt_check_result' || subModelName === 'act_cnt_review_result') {
            modelData[dataIndex] = {
              ...modelData[dataIndex],
              chapter, content, no_text, official_comment, rich_content, attaches, no_number, reference_link,
            };
          } else if (subModelName === 'idtf_check_result' || subModelName === 'idtf_review_result' || subModelName === 'overall_review_result') {
            modelData[dataIndex] = {
              ...modelData[dataIndex],
              ll_comment,
              effects,
            };
          }
        }
        data.dot = this.setDot(data, subModelName, checkData);
      } else if (type === 'related_template') {
        if (data === undefined) return;
        const templateCheckDataList = checkedList.filter(item => item[`${tabValue}_version`] !== undefined);
        const tarIndex = templateCheckDataList.findIndex(item => item[`${tabValue}_version`] === data.last_version.id);
        const checkData = templateCheckDataList[tarIndex];
        const _data = data.last_version === undefined
          ? data
          : data.last_version.act_idtf_assignment_item === undefined
          ? data
          : data.last_version.act_idtf_assignment_item;
        keys.forEach(key => {
          if (data[key] !== undefined) {
            return;
          } else {
            data[key] = _data[key] !== undefined ? _data[key] : null;
          }
        });
        if (templateCheckDataList.length > 0 && tarIndex >= 0) {
          modelData[dataIndex][subModelName] = checkData[subModelName];
        }
        data.dot = this.setDot(data, subModelName, checkData);
      }
    })
  },
  setDot(data, subModelName) {
    const green = {color: 'green'};
    const red = {color: 'red'};
    const yellow = {color: 'yellow'};
    const result = data[subModelName];
    if (result == null) return red;
    return result == 1 ? green : yellow;
  },
  setFields(modelData, subModelName, isCommentIdtf, isStageFinished) {
    if (modelData.length === 0) return [];
    let fields = {
      act: {},
      article: {},
    };
    if (!isCommentIdtf && (
      subModelName === 'idtf_check_result' ||
      subModelName === 'idtf_review_result' ||
      subModelName === 'overall_review_result'
    )) {
      fields = {
        ...fields,
        related_template: {},
      };
    }
    for (let key in fields) {
      let field = fields[key];
      if (key === "act") {
        field = this.getActFields(subModelName);
      } else if (key === "article") {
        field = this.getArticleFields(subModelName);
      } else if (key === "related_template") {
        field = this.getTemplateFields();
      }

      if (field.id !== undefined) {
        field.id = modelData[1].act_version.act.id;
      }

      if (field.versionId !== undefined) {
        field.versionId = modelData[1].act_version.id;
      }
      field.displayHideFields = this.$_getDisplayHideFields(subModelName, key);
      field.updateHideFields = this.$_getUpdateHideFields(subModelName, key);
      field.customHideFields = this.$_getCustomHideFields(subModelName, key);
      field.showFields = this.$_getShowFields(subModelName, key, isStageFinished);
      field.inRowCustomBtns = this.$_getCustomBtns(subModelName, key, isCommentIdtf, isStageFinished);
      field.filterSelects = this.$_getFilterSelects(subModelName, key, modelData)
      field.readDialogSetting= this.$_getReadDialogSetting(subModelName, key, isStageFinished);
      field.updateDialogSetting= this.$_getUpdateDialogSetting(key);
      fields[key] = field;
      field.isMultiSelect = key === "article" || key === "related_template";
      field.hasMultiDeleteBtn = false;
      field.setSplitPaneData = this.$_getSetSplitPaneData(subModelName, key);
      field.updateIdtfItems = this.$_getUpdateIdtfItems(subModelName, key);
    }
    return fields
  },
  setFetchSetting(id) {
    const fetchSetting = [
      {
        url: "act_idtf_assignment_item",
        params: { "act_idtf_assignment": id },
      },
      {
        url: `act_idtf_assignment/${id}`,
      },
    ]
    return fetchSetting
  },
  updateUpdateData(updateData, data, fieldKey, index) {
    if (updateData[fieldKey] === undefined) {
      updateData[fieldKey] = [];
      updateData[fieldKey].push(data);
    } else {
      if (index >= 0) {
        if (
          updateData[fieldKey][index][fieldKey] &&
          data[fieldKey] &&
          updateData[fieldKey][index][fieldKey] === data[fieldKey]
        ) {
          updateData[fieldKey].splice(index, 1);
        } else {
          updateData[fieldKey][index] = data;
        }
      } else {
        updateData[fieldKey].push(data);
      }
    }
  },
  getVersionId($event, modelData, getVersionId, tarModelData) {
    const versionId = getVersionId({
      modelData: modelData,
      updateData: $event,
      tarModelData,
    })
    return versionId
  },
  getVersionKey(tab, modelName) {
    const versionKey = tab
    ? `${tab.value}_version`
    : modelName
    return versionKey
  },
  getUpdateDataIndex(data, key, id) {
    const index = data
    ? data.findIndex((_data) => _data[`${key}`] === id)
    : null
    return index
  },
  getActFields(subModelName) {
    const label = subModelName === 'act_cnt_check_result'
      ? '編輯法規格式內容'
      : subModelName === 'act_cnt_review_result'
      ? '覆核法規格式內容'
      : subModelName === 'idtf_check_result'
      ? '法規鑑別'
      : subModelName === 'idtf_review_result'
      ? '覆核法規鑑別'
      : subModelName === 'overall_review_result'
      ? '總覆核鑑別'
      : '';
    const field = {
      label,
      modelName: "act_version",
      fields: actModel.fields,
      showExpand: false,
      inRowBtnRead: false,
      inRowBtnUpdate: false,
      inRowBtnDelete: false,
      isCreatable: false,
      isFilterShow: false,
      hasSearchBtn: false,
      id: null,
      isPaginationShow: false,
      getUrl: function (id) {
        return `act/${id}`;
      },
      getSubmitUrl(datas) {
        const actVersionId = datas.modelData[1].act_version.id;
        const actIdtfAssignmentItemId = datas.modelData[0].find(item => item.act_version !== null && item.act_version.id === actVersionId).id;
        return subModelName === 'act_cnt_check_result' || subModelName === 'act_cnt_review_result'
          ? `/act_version/${actVersionId}`
          : `/act_idtf_assignment_item/${actIdtfAssignmentItemId}`;
      },
      getVersionId(datas) {
        return datas.modelData[1].act_version.id;
      },
      setUpdateData: ({id, act_comment, ll_comment, name, short_name, status, attaches, reference_link}, modelData) => {
        const locale = store.state.locale.selectingLocale
        if (subModelName === 'act_cnt_check_result' || subModelName === 'act_cnt_review_result') {
          return {
            id, act_comment, ll_comment, name, short_name, status, attaches, reference_link,
            locales: {
              [`${locale}`]: {act_comment, ll_comment, name, short_name, status}
            },
          };
        } else if (subModelName === 'idtf_check_result' || subModelName === 'idtf_review_result' || subModelName === 'overall_review_result') {
          return {
            act_idtf_assignment: modelData[1].id,
            locales: {
              [`${locale}`]: {ll_comment},
            },
          }
        }
      },
      getIdtfAssigmentItemId(data, rawIdtfItems) {
        const actVersionId = data.last_version.id;
        const actIdtfItem = rawIdtfItems
          .filter(item => item.act_version !== null)
          .find(item => item.act_version.id === actVersionId);
        if (actIdtfItem) {
          return actIdtfItem.id;
        } else {
          return null;
        }
      },
      getCompareDialogValueFunction: {
        getFirstValue: function (modelData, fieldKey) {
          if (!modelData) return '';
          const text =
            modelData.last_second_version !== undefined &&
            modelData.last_second_version !== null &&
            modelData.last_second_version[fieldKey] !== undefined
              ? modelData.last_second_version[fieldKey]
              : null;
          return text;
        },
        getSecondValue: function (modelData, fieldKey) {
          if (!modelData) return '';
          const text =
            modelData.last_version !== undefined &&
            modelData.last_version[fieldKey] !== undefined
              ? modelData.last_version[fieldKey]
              : modelData[fieldKey]
              ? modelData[fieldKey]
              : null;
          return text;
        },
      },
      setDialogShowData(tarModelData) {
        const {ll_comment, idtf_remark} = tarModelData.last_version.act_idtf_assignment_item;
        return {
          ...tarModelData,
          last_version: {
            ...tarModelData.last_version,
            act_idtf_assignment_item: {
              ...tarModelData.last_version.act_idtf_assignment_item,
              ll_comment,
              idtf_remark,
            },
            ll_comment,
            idtf_remark,
          },
          ll_comment,
          idtf_remark,
        };
      }
    }
    return field
  },
  getArticleFields(subModelName) {
    const field = {
      orderBy: "no_number",
      orderWay: "asc",
      modelName: "article_version",
      showTitlebar: true,
      label: "法條",
      fields: articleModel.fields,
      readDialogTitleKey: "no_text",
      showExpand: false,
      inRowBtnRead: false,
      inRowBtnUpdate: false,
      inRowBtnDelete: false,
      isCreatable: false,
      isComparable: true,
      isFilterShow: true,
      versionId: null,
      getParams: (id) => {
        const params = {
          act_versions: id,
        };
        return params;
      },
      fetchDialogData: async (itemData) => {
        const id = itemData.article.id;
        try {
          const res = await axios.get("article_version", {
            params: {
              locale: "tw",
              order_by: "announce_at",
              order_way: "desc",
              article: id,
            },
          });
          itemData["last_second_version"] = res.data.data[1]
            ? res.data.data[1]
            : null;
        } catch (error) {
          alert(error);
        }
      },
      getSubmitUrl(datas) {
        const articleVersionId = datas.id;
        const articleIdtfAssignmentItemId = datas.modelData[0].find(item => item.article_version !== null && item.article_version.id === articleVersionId).id;
        return subModelName === 'act_cnt_check_result' || subModelName === 'act_cnt_review_result'
          ? `/article_version/${articleVersionId}`
          : `/act_idtf_assignment_item/${articleIdtfAssignmentItemId}`;
      },
      getVersionId(datas) {
        return datas.updateData.id;
      },
      setUpdateData: ({id, chapter, content, no_text, official_comment, rich_content, attaches, no_number, reference_link, ll_comment, effectsItem}, modelData) => {
        const locale = store.state.locale.selectingLocale
        if (subModelName === 'act_cnt_check_result' || subModelName === 'act_cnt_review_result') {
          return {
            id, chapter, content, no_text, official_comment, rich_content, attaches, no_number, reference_link,
            locales: {
              [`${locale}`]: {chapter, content, no_text, official_comment, rich_content}
            },
          }
        } else if (subModelName === 'idtf_check_result' || subModelName === 'idtf_review_result' || subModelName === 'overall_review_result') {
          return {
            act_idtf_assignment: modelData[1].id,
            locales: {
              [`${locale}`]: {ll_comment}
            },
            effects: effectsItem ? effectsItem.map(({value: id, text: name}) => ({id, name})) : [],
          }
        }
      },
      getIdtfAssigmentItemId(data, rawIdtfItems) {
        const articleVersionId = data.id;
        const articleIdtfItem = rawIdtfItems
          .filter(item => item.article_version !== null)
          .find(item => item.article_version.id === articleVersionId);
        if (articleIdtfItem) {
          return articleIdtfItem.id;
        } else {
          return null;
        }
      },
      getCompareDialogValueFunction: {
        getFirstValue: function (modelData, fieldKey) {
          if (!modelData) return '';
          const text =
            modelData.last_second_version !== undefined &&
            modelData.last_second_version !== null &&
            modelData.last_second_version[fieldKey] !== undefined
              ? modelData.last_second_version[fieldKey]
              : null;
          return text;
        },
        getSecondValue: function (modelData, fieldKey) {
          if (!modelData) return '';
          const text =
            modelData.last_version !== undefined &&
            modelData.last_version[fieldKey] !== undefined
              ? modelData.last_version[fieldKey]
              : modelData[fieldKey]
              ? modelData[fieldKey]
              : null;
          return text;
        },
      },
      setSubmitData(rawData) {
        if (!rawData.effects || rawData.effects.length === 0) return rawData;
        const effects = [];
        rawData.effects.forEach(({id}) => {
          if (id) effects.push(id);
        });
        return {
          ...rawData,
          effects,
        };
      },
      setDialogShowData(tarModelData) {
        const {ll_comment, effects} = tarModelData.act_idtf_assignment_item;
        return {
          ...tarModelData,
          act_idtf_assignment_item: {
            ...tarModelData.act_idtf_assignment_item,
            ll_comment,
            effects,
          },
          ll_comment,
          effects,
        };
      }
    }
    return field
  },
  getTemplateFields() {
    const field = {
      modelName: 'act_idtf_assignment',
      showTitlebar: true,
      label: "相關連動公版",
      fields: actModel.fields,
      pageMode: true,
      showExpand: false,
      inRowBtnRead: false,
      inRowBtnUpdate: false,
      inRowBtnDelete: false,
      isCreatable: false,
      versionId: null,
      isVtabsShow: true,
      tab: {
        value: "license_template",
        items: [
          {
            text: "證照公版",
            value: "license_template",
          },
          {
            text: "內訓公版",
            value: "internal_training_template",
          },
          {
            text: "點檢表公版",
            value: "checklist_template",
          },
          {
            text: "稽核表公版",
            value: "audit_template",
          },
          {
            text: "承攬商資格證",
            value: "contractor_license_template",
          },
        ],
      },
      isFilterShow: true,
      getUrl: (actVersionId, tabValue) => {
        return `${tabValue}/act_version/${actVersionId}`
      },
      getVersionId(datas) {
        return datas.tarModelData.last_version.id;
      },
      getIdtfAssigmentItemId(data, rawIdtfItems, versionKey, versionId) {
        const templateIdtfItem = rawIdtfItems
          .filter(item => item[versionKey] !== null)
          .find(item => item[versionKey].id === versionId);
        if (templateIdtfItem) {
          return templateIdtfItem.id;
        } else {
          return null;
        }
      },
    }
    return field
  },
  $_getFilterSelects(subModelName, fieldKey, modelData) {
    if (fieldKey === 'act') return;
    const checkResultFields = [
      {
        modelName: "act_cnt_review_result",
        placeholder: "篩選內容覆核結果",
      },
      {
        modelName: "idtf_check_result",
        placeholder: "篩選鑑別結果",
      },
      {
        modelName: "idtf_review_result",
        placeholder: "篩選鑑別覆核結果",
      },
      {
        modelName: "overall_review_result",
        placeholder: "篩選總覆核結果",
      },
    ];
    const checkResultFilters = checkResultFields.map(field => {
      const { modelName, placeholder } = field;
      return {
        type: "select",
        label: "",
        modelName,
        placeholder,
        textKey: "name",
        items: [
          {
            text: "-",
            value: "",
          },
          {
            text: "通過",
            value: "1",
          },
          {
            text: "不通過",
            value: "0",
          },
        ],
        defaultValue: "",
      }
    });
    const factoryFilters = [
      {
        type: "select",
        label: "",
        modelName: "range_type",
        placeholder: "篩選適用範圍類型",
        textKey: "name",
        items: [
          {
            text: "所有類型",
            value: "",
          },
          {
            text: "通用",
            value: "general",
          },
          {
            text: "專屬",
            value: "exclusive",
          },
        ],
        defaultValue: "",
      },
      {
        type: "hasMany",
        label: "",
        modelName: "factory",
        paramName: "exclusive_factories",
        placeholder: "篩選專屬工廠",
        textKey: "name",
        getText(item) {
          return H_helpers.methods.$_CMS_getFactoryName(item);
        },
      },
      {
        type: "hasMany",
        label: "",
        modelName: "factory",
        paramName: "factories",
        placeholder: "篩選適用工廠",
        textKey: "name",
        getText(item) {
          return H_helpers.methods.$_CMS_getFactoryName(item);
        },
      },
    ]
    const isArticleVersionUpdatedFilter = {
      type: "select",
      label: "",
      modelName: "act_version",
      placeholder: "篩選更新版本",
      textKey: "name",
      getItems: () => {
        const actVersionId = modelData[1].act_version.id;
        return [
          {
            text: "全部",
            value: "",
          },
          {
            text: "更新",
            value: `${actVersionId}`,
          },
        ]
      },
      defaultValue: `${modelData[1].act_version.id}`,
    };
    let resultFilterSelects = [];
    if (subModelName === 'act_cnt_check_result') {
      resultFilterSelects = checkResultFilters.filter(filter => filter.modelName === 'act_cnt_review_result');
    } else if (subModelName === 'act_cnt_review_result') {
      resultFilterSelects = checkResultFilters.filter(filter => filter.modelName === 'idtf_check_result');
    } else if (subModelName === 'idtf_check_result') {
      resultFilterSelects = checkResultFilters.filter(filter => filter.modelName === 'idtf_review_result');
    } else if (subModelName === 'idtf_review_result' || subModelName === 'overall_review_result') {
      resultFilterSelects = checkResultFilters.filter(filter => filter.modelName === 'overall_review_result');
    }
    if (
      subModelName === 'act_cnt_check_result' ||
      subModelName === 'act_cnt_review_result' ||
      (( subModelName === 'idtf_check_result' ||
          subModelName === 'idtf_review_result' ||
          subModelName === 'overall_review_result'
      ) &&fieldKey === 'article')
    ) {
      resultFilterSelects = [
        ...resultFilterSelects,
        isArticleVersionUpdatedFilter,
      ];
    } else if (
      (( subModelName === 'idtf_check_result' ||
          subModelName === 'idtf_review_result' ||
          subModelName === 'overall_review_result'
      ) && fieldKey === 'related_template')
    ) {
      resultFilterSelects = [
        ...resultFilterSelects,
        ...factoryFilters,
      ];
    }
    return resultFilterSelects;
  },
  $_getCustomBtns(subModelName, fieldKey, isCommentIdtf, isStageFinished) {
    const btnList = [
      {
        type: "checkPass",
        value: 1,
        tooltip: "鑑別通過",
        disabledKey: "isInRowBtnCheckPassDisabled",
        icon: "mdi-check",
        action: (data) => {
          data[`${subModelName}`] = data[`${subModelName}`] === '通過' ? '-' : '通過';
        },
      },
      {
        type: "checkFail",
        value: 0,
        tooltip: "鑑別不通過",
        disabledKey: "isInRowBtnCheckPassDisabled",
        icon: "mdi-close",
        action: (data) => {
          data[`${subModelName}`] = data[`${subModelName}`] === '不通過' ? '-' : '不通過';
        },
      },
      {
        type: "update",
        tooltip: "編輯",
        disabledKey: "isInRowBtnUpdateDisabled",
        icon: "mdi-pencil",
      },
      {
        type: "read",
        tooltip: "查看",
        icon: "mdi-eye",
      },
      {
        type: 'delete',
        tooltip: '刪除',
        icon: 'mdi-delete',
      },
    ];
    if (isStageFinished) return btnList.filter(btn => btn.type === 'read');
    const btnWithoutDelete = btnList.filter(btn => btn.type !== 'delete');
    const btnWithoutCheckFailAndDelete = btnList.filter(btn => btn.type !== 'checkFail' && btn.type !== 'delete')
    if ( subModelName === 'act_cnt_check_result' ) {
      return fieldKey === 'act'
        ? btnWithoutCheckFailAndDelete
        : btnList.filter(btn => btn.type !== 'checkFail');
    } else if ( subModelName === 'act_cnt_review_result' ) {
      return btnList;
    } else if ( subModelName === 'idtf_check_result' ) {
      if ( fieldKey === 'act' || fieldKey === 'article' ) {
        return isCommentIdtf ? btnWithoutCheckFailAndDelete : btnWithoutDelete;
      } else if ( fieldKey === 'related_template' ) {
        const templateBtnList = btnList.filter(btn => btn.type === 'checkPass' || btn.type === 'read');
        return this.$_setTemplateBtnList(templateBtnList);
      }
    } else if ( subModelName === 'idtf_review_result' || subModelName === 'overall_review_result' ) {
      if ( fieldKey === 'act' || fieldKey === 'article' ) {
        return btnWithoutDelete;
      } else if ( fieldKey === 'related_template' ) {
        const templateBtnList = btnList.filter(btn => btn.type !== 'update' || btn.type !== 'delete');
        return this.$_setTemplateBtnList(templateBtnList);
      }
    }
  },
  $_setTemplateBtnList(rawBtnList) {
    const tarIndex = rawBtnList.findIndex(btn => btn.type === 'read');
    rawBtnList[tarIndex].action = (data, tabValue, _this) => {
      const routeUrl = _this.$router.resolve({
        path: `/${tabValue}/${data.id}`,
      });
      window.open(routeUrl.href, "_blank");
    };
    return rawBtnList;
  },
  $_getShowFields(subModelName, fieldKey, isStageFinished) {
    let subModelFields = [];
    if (subModelName === 'act_cnt_check_result') {
      subModelFields = [
        "act_cnt_check_result",
        "act_cnt_review_result",
        "act_cnt_updated_admin",
        "act_cnt_updated_at",
        "act_cnt_final_reviewer",
        "act_cnt_final_reviewed_at",
      ];
    } else if (subModelName === 'act_cnt_review_result') {
      subModelFields = [
        "act_cnt_review_result",
        "idtf_check_result",
        "act_cnt_final_reviewer",
        "act_cnt_final_reviewed_at",
        "idtf_updated_admin",
        "idtf_updated_at",
      ];
    } else if (subModelName === 'idtf_check_result') {
      subModelFields = [
        "idtf_check_result",
        "idtf_review_result",
        "idtf_updated_admin",
        "idtf_updated_at",
        "idtf_final_reviewer",
        "idtf_final_reviewed_at",
      ];
    } else if (subModelName === 'idtf_review_result') {
      subModelFields = [
        "idtf_review_result",
        "overall_review_result",
        "idtf_final_reviewer",
        "idtf_final_reviewed_at",
        "overall_review_updated_admin",
        "overall_review_updated_at",
      ];
    } else if (subModelName === 'overall_review_result') {
      subModelFields = [
        "overall_review_result",
        "overall_review_updated_admin",
        "overall_review_updated_at",
      ];
    }
    if (fieldKey === 'act') {
      subModelFields = [
        "name", "icon",
        ...subModelFields
      ];
    } else if (fieldKey === 'article') {
      subModelFields = [
        "no_text", "icon",
        ...subModelFields
      ];
    } else if (fieldKey === 'related_template') {
      subModelFields = [
        "name", "exclusive_factories",
        ...subModelFields
      ];
    }
    if (!isStageFinished) {
      subModelFields.unshift('dot');
    }
    return subModelFields;
  },
  $_getReadDialogSetting(subModelName, fieldKey, isStageFinished) {
    if (fieldKey === 'related_template' || isStageFinished) return {};
    let readDialogSetting = {
      customBtns: {},
    };
    if (subModelName === 'act_cnt_check_result') {
      readDialogSetting.customBtns = {
        right: [
          {
            title: `編輯`,
            color: "textSecondary",
            outlined: true,
            emit: "custom-emit",
          },
        ],
      };
    } else if (
      subModelName === 'act_cnt_review_result' ||
      subModelName === 'idtf_review_result' ||
      subModelName === 'overall_review_result'
    ) {
      readDialogSetting.customBtns = {
        left: [
          {
            title: `編輯鑑別`,
            color: "textSecondary",
            outlined: true,
            emit: "custom-emit",
          },
        ],
        right: [
          {
            title: `不通過`,
            color: "deleteBtn white--text",
            outlined: false,
            emit: "custom-emit",
            value: 0,
            icon: "mdi-close",
          },
          {
            title: `通過`,
            outlined: false,
            emit: "custom-emit",
            value: 1,
            icon: "mdi-check",
          },
        ],
      };
    } else if (subModelName === 'idtf_check_result') {
      readDialogSetting.customBtns = {
        right: [
          {
            title: `填寫鑑別`,
            color: "textSecondary",
            outlined: true,
            emit: "custom-emit",
          },
        ],
      };
    }
    return readDialogSetting;
  },
  $_getUpdateDialogSetting(fieldKey) {
    if (fieldKey === 'related_template') return {};
    const updateDialogSetting = {
      customBtns: {
        left: [
          {
            title: `查看內容`,
            color: "textSecondary",
            outlined: true,
            emit: "custom-emit",
          },
        ],
      },
    };
    return updateDialogSetting;
  },
  $_getDisplayHideFields(subModelName, fieldKey) {
    if (fieldKey === 'related_template') return;
    let displayHideFields = [];
    if (fieldKey === 'act') {
      displayHideFields = [
        "query",
        "icon",
        "updated_admin",
        "updated_at",
        "act_version",
        "no_text",
        "act_cnt_status",
        "idtf_status",
        "created_at",
        "created_admin",
        "last_version",
        "sequence",
        "area",
        "act_type",
        "industry_categories",
        "system_classes",
        "system_subclasses",
        "range_type",
        "factories",
        "exclusive_factories",
        "act_cnt_updated_at",
        "act_cnt_updated_admin",
        "act_cnt_final_reviewed_at",
        "act_cnt_final_reviewer",
        "idtf_updated_at",
        "idtf_updated_admin",
        "idtf_final_reviewed_at",
        "idtf_final_reviewer",
        "overall_owners",
        "km_owners",
        "km_backups",
        "km_reviewers",
        "idtf_owners",
        "idtf_backups",
        "idtf_reviewers",
        "locales",
        "overall_review_updated_at",
        "overall_review_updated_admin",
        "btnLoading",
        "dot",
        "has_released_first",
        "has_idtf",
        "overall_review_status",
        "idtf_owners",
        "idtf_backups",
        "idtf_reviewers",
        "overall_owners",
      ];
      if (subModelName === 'act_cnt_check_result') {
        displayHideFields = [
          ...displayHideFields,
          "announce_at",
          "effect_at",
          "overall_review_result",
          "overall_review_remark",
          "idtf_review_result",
          "act_cnt_check_result",
          "idtf_check_result",
          "area_sections",
          "idtf_final_review_remark",
          "idtf_overall_reviewed_at",
          "idtf_overall_reviewer",
          "idtf_remark",
        ];
      } else if (subModelName === 'act_cnt_review_result') {
        displayHideFields = [
          ...displayHideFields,
          "announce_at",
          "effect_at",
          "overall_review_result",
          "overall_review_remark",
          "act_cnt_check_result",
          "idtf_check_result",
          "idtf_final_review_remark",
          "idtf_overall_reviewed_at",
          "idtf_overall_reviewer",
          "act_cnt_final_review_remark",
          "act_cnt_review_result",
        ];
      } else if (subModelName === 'idtf_check_result') {
        displayHideFields = [
          ...displayHideFields,
          "announce_at",
          "effect_at",
          "overall_review_result",
          "overall_review_remark",
          "act_cnt_check_result",
          "idtf_check_result",
          "act_cnt_final_review_remark",
          "act_cnt_review_result",
          "idtf_overall_reviewed_at",
          "idtf_overall_reviewer",
          "idtf_remark",
        ];
      } else if (subModelName === 'idtf_review_result') {
        displayHideFields = [
          ...displayHideFields,
          "idtf_overall_reviewer",
          "idtf_overall_reviewed_at",
          "act_cnt_final_review_remark",
          "act_cnt_review_result",
          "act_cnt_check_result",
          "idtf_check_result",
          "idtf_final_review_remark",
          "idtf_review_result",
          "idtf_remark",
        ];
      } else if (subModelName === 'overall_review_result') {
        displayHideFields = [
          ...displayHideFields,
          "idtf_check_result",
          "idtf_review_result",
          "act_cnt_check_result",
          "act_cnt_final_review_remark",
          "act_cnt_review_result",
          "idtf_final_review_remark",
          "idtf_remark",
          "idtf_overall_reviewed_at",
          "idtf_overall_reviewer",
        ];
      }
    }
    if (fieldKey === 'article') {
      displayHideFields = [
        "icon",
        "updated_admin",
        "updated_at",
        "isInRowBtnCheckPassDisabled",
        "isInRowBtnCheckFailDisabled",
        "isInRowBtnUpdateDisabled",
        "act_cnt_check_result",
        "act_cnt_updated_at",
        "act_cnt_updated_admin",
        "act_cnt_final_reviewed_at",
        "act_cnt_final_reviewer",
        "idtf_check_result",
        "idtf_updated_admin",
        "idtf_updated_at",
        "idtf_final_reviewer",
        "idtf_final_reviewed_at",
        "official_comment",
        "btnLoading",
        "dot",
        "has_released_first",
        "has_idtf",
        "idtf_owners",
        "idtf_backups",
        "idtf_reviewers",
        "overall_owners",
      ];
      if (subModelName === 'act_cnt_check_result') {
        displayHideFields = [
          ...displayHideFields,
          "overall_review_result",
          "overall_review_remark",
          "idtf_review_result",
          "idtf_final_review_remark",
          "idtf_overall_reviewed_at",
          "idtf_overall_reviewer",
          "overall_review_updated_at",
          "overall_review_updated_admin",
          "idtf_remark",
        ];
      } else if (subModelName === 'act_cnt_review_result') {
        displayHideFields = [
          ...displayHideFields,
          "overall_review_result",
          "overall_review_remark",
          "idtf_final_review_remark",
          "idtf_overall_reviewed_at",
          "idtf_overall_reviewer",
          "overall_review_updated_at",
          "overall_review_updated_admin",
          "act_cnt_final_review_remark",
          "act_cnt_review_result",
        ];
      } else if (subModelName === 'idtf_check_result') {
        displayHideFields = [
          ...displayHideFields,
          "overall_review_result",
          "overall_review_remark",
          "act_cnt_final_review_remark",
          "act_cnt_review_result",
          "idtf_overall_reviewed_at",
          "idtf_overall_reviewer",
          "overall_review_updated_at",
          "overall_review_updated_admin",
          "idtf_remark",
        ];
      } else if (subModelName === 'idtf_review_result') {
        displayHideFields = [
          ...displayHideFields,
          "idtf_final_reviewed_at",
          "idtf_updated_at",
          "idtf_updated_admin",
          "overall_review_updated_at",
          "overall_review_updated_admin",
          "act_cnt_review_result",
          "idtf_final_reviewer",
          "act_cnt_final_review_remark",
          "idtf_final_review_remark",
          "idtf_review_result",
          "idtf_overall_reviewed_at",
          "idtf_overall_reviewer",
          "overall_review_updated_at",
          "overall_review_updated_admin",
          "idtf_remark",
        ];
      } else if (subModelName === 'overall_review_result') {
        displayHideFields = [
          ...displayHideFields,
          "act_cnt_final_review_remark",
          "act_cnt_review_result",
          "idtf_final_review_remark",
          "idtf_review_result",
          "act_cnt_updated_at",
          "idtf_remark",
          "idtf_overall_reviewed_at",
          "idtf_overall_reviewer",
          "overall_review_updated_at",
          "overall_review_updated_admin",
        ];
      }
    }
    return displayHideFields;
  },
  $_getUpdateHideFields(subModelName, fieldKey) {
    if (fieldKey === 'related_template') return;
    let updateHideFields = [];
    if (fieldKey === 'act') {
      updateHideFields = [
        "query",
        "icon",
        "updated_admin",
        "updated_at",
        "act_version",
        "no_text",
        "act_cnt_status",
        "idtf_status",
        "created_at",
        "created_admin",
        "last_version",
        "sequence",
        "area",
        "act_type",
        "industry_categories",
        "system_classes",
        "system_subclasses",
        "range_type",
        "factories",
        "exclusive_factories",
        "act_cnt_updated_at",
        "act_cnt_updated_admin",
        "act_cnt_final_reviewed_at",
        "act_cnt_final_reviewer",
        "idtf_updated_at",
        "idtf_updated_admin",
        "idtf_final_reviewed_at",
        "idtf_final_reviewer",
        "overall_owners",
        "km_owners",
        "km_backups",
        "km_reviewers",
        "idtf_owners",
        "idtf_backups",
        "idtf_reviewers",
        "locales",
        "btnLoading",
        "dot",
        "has_released_first",
        "has_idtf",
        "idtf_owners",
        "idtf_backups",
        "idtf_reviewers",
        "overall_owners",
      ];
      if (subModelName === 'act_cnt_check_result') {
        updateHideFields = [
          ...updateHideFields,
          "announce_at",
          "effect_at",
          "overall_review_updated_at",
          "overall_review_updated_admin",
          "act_cnt_final_review_remark",
          "area_sections",
          "areas",
          "idtf_final_review_remark",
          "idtf_review_result",
          "overall_review_remark",
          "overall_review_result",
          "idtf_remark",
          "ll_comment",
        ];
      } else if (subModelName === 'act_cnt_review_result') {
        updateHideFields = [
          ...updateHideFields,
          "announce_at",
          "effect_at",
          "overall_review_updated_at",
          "overall_review_updated_admin",
          "act_cnt_final_review_remark",
          "act_cnt_review_result",
          "idtf_final_review_remark",
          "idtf_review_result",
          "overall_review_remark",
          "overall_review_result",
          "area_sections",
          "areas",
          "idtf_remark",
          "ll_comment",
        ];
      } else if (subModelName === 'idtf_check_result') {
        updateHideFields = [
          ...updateHideFields,
          "overall_review_result",
          "overall_review_remark",
          "overall_review_updated_at",
          "overall_review_updated_admin",
          "act_cnt_final_review_remark",
          "idtf_remark",
        ];
      } else if (subModelName === 'idtf_review_result') {
        updateHideFields = [
          ...updateHideFields,
          "idtf_check_result",
          "idtf_overall_reviewer",
          "idtf_overall_reviewed_at",
          "act_cnt_check_result",
          "act_cnt_final_review_remark",
          "act_cnt_review_result",
          "overall_review_updated_at",
          "overall_review_updated_admin",
          "idtf_final_review_remark",
          "idtf_review_result",
          "idtf_remark",
        ];
      } else if (subModelName === 'overall_review_result') {
        updateHideFields = [
          ...updateHideFields,
          "idtf_check_result",
          "idtf_review_result",
          "act_cnt_check_result",
          "act_cnt_final_review_remark",
          "act_cnt_review_result",
          "idtf_final_review_remark",
          "act_cnt_final_review_remark",
          "idtf_check_result",
          "idtf_review_result",
          "act_cnt_final_review_remark",
          "idtf_final_review_remark",
          "idtf_review_result",
          "idtf_remark",
        ];
      }
    }
    if (fieldKey === 'article') {
      updateHideFields = [
        "icon",
        "isInRowBtnCheckPassDisabled",
        "isInRowBtnCheckFailDisabled",
        "isInRowBtnUpdateDisabled",
        "act_cnt_final_review_remark",
        "official_comment",
        "btnLoading",
        "dot",
        "has_released_first",
        "has_idtf",
        "idtf_owners",
        "idtf_backups",
        "idtf_reviewers",
        "overall_owners",
      ];
      if (subModelName === 'act_cnt_check_result') {
        updateHideFields = [
          ...updateHideFields,
          "ll_comment",
          "announce_at",
          "effect_at",
          "effects",
          "act_cnt_check_result",
          "act_cnt_review_result",
          "act_cnt_updated_at",
          "act_cnt_updated_admin",
          "overall_review_result",
          "overall_review_remark",
          "idtf_check_result",
          "idtf_review_result",
          "idtf_updated_admin",
          "idtf_updated_at",
          "idtf_final_reviewer",
          "idtf_final_reviewed_at",
          "act_cnt_final_review_remark",
          "idtf_final_review_remark",
          "idtf_remark",
          "ll_comment",
        ];
      } else if (subModelName === 'act_cnt_review_result') {
        updateHideFields = [
          ...updateHideFields,
          "ll_comment",
          "announce_at",
          "effect_at",
          "effects",
          "act_cnt_check_result",
          "act_cnt_review_result",
          "act_cnt_updated_at",
          "act_cnt_updated_admin",
          "overall_review_result",
          "overall_review_remark",
          "idtf_check_result",
          "idtf_review_result",
          "idtf_updated_admin",
          "idtf_updated_at",
          "idtf_final_reviewer",
          "idtf_final_reviewed_at",
          "act_cnt_final_review_remark",
          "idtf_final_review_remark",
          "idtf_remark",
          "ll_comment",
        ];
      } else if (subModelName === 'idtf_check_result') {
        updateHideFields = [
          ...updateHideFields,
          "updated_admin",
          "updated_at",
          "announce_at",
          "effect_at",
          "idtf_check_result",
          "idtf_updated_admin",
          "idtf_updated_at",
          "idtf_final_reviewer",
          "idtf_final_reviewed_at",
          "overall_review_remark",
          "overall_review_result",
          "idtf_remark",
        ];
      } else if (subModelName === 'idtf_review_result') {
        updateHideFields = [
          ...updateHideFields,
          "updated_admin",
          "updated_at",
          "act_cnt_final_review_remark",
          "idtf_final_review_remark",
          "idtf_review_result",
          "idtf_remark",
        ];
      } else if (subModelName === 'overall_review_result') {
        updateHideFields = [
          ...updateHideFields,
          "updated_admin",
          "updated_at",
          "idtf_final_review_remark",
          "idtf_review_result",
          "idtf_remark",
        ];
      }
    }
    return updateHideFields;
  },
  $_getCustomHideFields(subModelName, fieldKey) {
    if (
      subModelName === 'act_cnt_check_result'
    ) {
      return;
    }
    let customHideFields = [];
    if (fieldKey === 'act') {
      customHideFields = [
        "query",
        "name",
        "short_name",
        "act_comment",
        "status",
        "ll_comment",
        "reference_link",
        "attaches",
        "announce_at",
        "effect_at",
        "overall_review_result",
        "icon",
        "updated_admin",
        "updated_at",
        "act_version",
        "no_text",
        "act_cnt_status",
        "idtf_status",
        "created_at",
        "created_admin",
        "last_version",
        "sequence",
        "area",
        "act_type",
        "industry_categories",
        "system_classes",
        "system_subclasses",
        "range_type",
        "factories",
        "exclusive_factories",
        "act_cnt_updated_at",
        "act_cnt_updated_admin",
        "act_cnt_final_reviewed_at",
        "act_cnt_final_reviewer",
        "idtf_updated_at",
        "idtf_updated_admin",
        "idtf_final_reviewed_at",
        "idtf_final_reviewer",
        "overall_owners",
        "km_owners",
        "km_backups",
        "km_reviewers",
        "idtf_owners",
        "idtf_backups",
        "idtf_reviewers",
        "locales",
        "overall_review_updated_at",
        "overall_review_updated_admin",
        "act_cnt_check_result",
        "act_cnt_review_result",
        "idtf_check_result",
        "idtf_review_result",
        "area_sections",
        "areas",
        "btnLoading",
        "dot",
        "has_released_first",
        "has_idtf",
        "idtf_overall_reviewed_at",
        "idtf_overall_reviewer",
        "overall_review_status"
      ];
      if (subModelName === 'act_cnt_review_result') {
        customHideFields = [
          ...customHideFields,
          "idtf_final_review_remark",
          "overall_review_remark",
          "idtf_remark",
        ];
      } else if (subModelName === 'idtf_check_result') {
        customHideFields = [
          ...customHideFields,
          "idtf_overall_reviewer",
          "idtf_overall_reviewed_at",
          "act_cnt_final_review_remark",
          "overall_review_remark",
          "idtf_final_review_remark",
        ];
      } else if (subModelName === 'idtf_review_result') {
        customHideFields = [
          ...customHideFields,
          "idtf_overall_reviewer",
          "idtf_overall_reviewed_at",
          "act_cnt_final_review_remark",
          "overall_review_remark",
          "idtf_remark",
        ];
      } else if (subModelName === 'overall_review_result') {
        customHideFields = [
          ...customHideFields,
          "act_cnt_final_review_remark",
          "idtf_final_review_remark",
          "idtf_remark",
        ];
      }
    } else if (fieldKey === 'article') {
      customHideFields = [
        "chapter",
        "no_text",
        "content",
        "rich_content",
        "official_comment",
        "ll_comment",
        "no_number",
        "announce_at",
        "effect_at",
        "attaches",
        "reference_link",
        "effects",
        "icon",
        "overall_review_result",
        "updated_at",
        "updated_admin",
        "isInRowBtnCheckPassDisabled",
        "isInRowBtnCheckFailDisabled",
        "isInRowBtnUpdateDisabled",
        "btnLoading",
        "dot",
        "overall_review_updated_at",
        "overall_review_updated_admin",
        "overall_review_status",
        "idtf_overall_reviewed_at",
        "idtf_overall_reviewer",
        "idtf_owners",
        "idtf_backups",
        "idtf_reviewers",
        "overall_owners",
      ];
      if (subModelName === 'act_cnt_review_result') {
        customHideFields = [
          ...customHideFields,
          "act_cnt_check_result",
          "act_cnt_final_reviewed_at",
          "act_cnt_final_reviewer",
          "act_cnt_review_result",
          "act_cnt_updated_admin",
          "act_cnt_updated_at",
          "overall_review_remark",
          "idtf_check_result",
          "idtf_review_result",
          "idtf_updated_admin",
          "idtf_updated_at",
          "idtf_final_reviewer",
          "idtf_final_reviewed_at",
          "idtf_final_review_remark",
          "idtf_remark",
        ];
      } else if (subModelName === 'idtf_check_result') {
        customHideFields = [
          ...customHideFields,
          "overall_review_updated_at",
          "overall_review_updated_admin",
          "overall_review_remark",
          "idtf_updated_at",
          "idtf_updated_admin",
          "idtf_review_result",
          "idtf_final_reviewer",
          "idtf_final_reviewed_at",
          "act_cnt_check_result",
          "act_cnt_final_reviewed_at",
          "act_cnt_final_reviewer",
          "act_cnt_review_result",
          "act_cnt_updated_admin",
          "act_cnt_updated_at",
          "act_cnt_final_review_remark",
          "idtf_check_result",
          "idtf_final_review_remark",
        ];
      } else if (subModelName === 'idtf_review_result') {
        customHideFields = [
          ...customHideFields,
          "overall_review_updated_at",
          "overall_review_updated_admin",
          "overall_review_remark",
          "idtf_updated_at",
          "idtf_updated_admin",
          "idtf_review_result",
          "idtf_final_reviewer",
          "idtf_final_reviewed_at",
          "act_cnt_check_result",
          "act_cnt_final_reviewed_at",
          "act_cnt_final_reviewer",
          "act_cnt_review_result",
          "act_cnt_updated_admin",
          "act_cnt_updated_at",
          "act_cnt_final_review_remark",
          "idtf_check_result",
          "idtf_remark",
        ];
      } else if (subModelName === 'overall_review_result') {
        customHideFields = [
          ...customHideFields,
          "overall_review_updated_at",
          "overall_review_updated_admin",
          "idtf_updated_at",
          "idtf_updated_admin",
          "idtf_review_result",
          "idtf_final_reviewer",
          "idtf_final_reviewed_at",
          "idtf_final_review_remark",
          "act_cnt_check_result",
          "act_cnt_final_reviewed_at",
          "act_cnt_final_reviewer",
          "act_cnt_review_result",
          "act_cnt_updated_admin",
          "act_cnt_updated_at",
          "act_cnt_final_review_remark",
          "idtf_check_result",
          "idtf_remark",
        ];
      }
    } else if (fieldKey === 'related_template') {
      if (subModelName === 'act_cnt_review_result') return;
      customHideFields = [
        "name",
        "short_name",
        "act_comment",
        "status",
        "ll_comment",
        "reference_link",
        "attaches",
        "announce_at",
        "effect_at",
        "overall_review_result",
        "icon",
        "updated_admin",
        "updated_at",
        "act_version",
        "no_text",
        "act_cnt_status",
        "idtf_status",
        "created_at",
        "created_admin",
        "last_version",
        "sequence",
        "area",
        "act_type",
        "industry_categories",
        "system_classes",
        "system_subclasses",
        "range_type",
        "factories",
        "exclusive_factories",
        "act_cnt_updated_at",
        "act_cnt_updated_admin",
        "act_cnt_final_reviewed_at",
        "act_cnt_final_reviewer",
        "idtf_updated_at",
        "idtf_updated_admin",
        "idtf_final_reviewed_at",
        "idtf_final_reviewer",
        "overall_owners",
        "km_owners",
        "km_backups",
        "km_reviewers",
        "idtf_owners",
        "idtf_backups",
        "idtf_reviewers",
        "locales",
        "query",
        "overall_review_updated_at",
        "overall_review_updated_admin",
        "idtf_review_result",
        "idtf_overall_reviewer",
        "idtf_overall_reviewed_at",
        "act_cnt_check_result",
        "act_cnt_final_review_remark",
        "act_cnt_review_result",
        "area_sections",
        "areas",
        "idtf_check_result",
        "btnLoading",
        "dot",
      ];
      if (subModelName === 'idtf_review_result') {
        customHideFields = [
          ...customHideFields,
          "overall_review_remark",
          "idtf_remark",
        ]
      } else if (subModelName === 'overall_review_result') {
        customHideFields = [
          ...customHideFields,
          "idtf_final_review_remark",
          "idtf_remark",
        ]
      }
    }
    return customHideFields;
  },
  isStageFinished(idtfData, subModelName) {
    if (!idtfData || !subModelName) return false;
    const statusConfig = {
      'act_cnt_update': { field: 'act_cnt_status', values: [2, 3] },
      'act_cnt_check_result': { field: 'act_cnt_status', values: [2, 3] },
      'act_cnt_review': { field: 'act_cnt_status', values: [3] },
      'act_cnt_review_result': { field: 'act_cnt_status', values: [3] },
      'idtf_update': { field: 'idtf_status', values: [2, 3] },
      'idtf_check_result': { field: 'idtf_status', values: [2, 3] },
      'idtf_review': { field: 'idtf_status', values: [3] },
      'idtf_review_result': { field: 'idtf_status', values: [3] },
      'idtf_review_overall': { field: 'overall_review_status', values: [2] },
      'overall_review_result': { field: 'overall_review_status', values: [2] },
    };
    const config = statusConfig[subModelName];
    if (!config) return false;
    return config.values.includes(idtfData[config.field]);
  },
  $_getSetSplitPaneData(subModelName, fieldKey) {
    if (fieldKey !== 'article') return;

  const remarkKeyList = Spare_idtf.remarkKeyList;
  const remarkKey = remarkKeyList[subModelName];

  return (rawData, actVersionId, allIdtfItems) => {
    const idtfItemsMap = new Map();
    allIdtfItems.forEach(idtfItem => {
      if (idtfItem.article_version && idtfItem.article_version.id) {
        idtfItemsMap.set(idtfItem.article_version.id, idtfItem);
      }
    });

    return rawData.map(item => {
      const tarIdtdItems = idtfItemsMap.get(item.id);
      const { ll_comment, effects } = tarIdtdItems || {};

      const processedEffects = effects ? effects.map(effect =>
        effect.id !== undefined ? effect.id : effect
      ) : item.effects;

      return {
        ...item,
        showUpdateChip: item.act_version.id === actVersionId,
        updateData: {},
        ll_comment: ll_comment || item.ll_comment,
        effects: processedEffects,
        isPass: tarIdtdItems ? tarIdtdItems[subModelName] : null,
        isPassRemark: tarIdtdItems ? tarIdtdItems[remarkKey] : null
      };
    });
  };
  },
  $_getUpdateIdtfItems(subModelName, fieldKey) {
    if (fieldKey !== 'article') return;
    const remarkKeyList = Spare_idtf.remarkKeyList;
    const remarkKey = remarkKeyList[subModelName];
    return (idtfItems, $event) => {
      const { id, ll_comment, effects, isCheckedValueSame, [subModelName]: checkedValue, article_version, [remarkKey]: remarkValue} = $event;
      const eventArticleVersionId = article_version ? article_version : id;
      const tarIdtfItem = idtfItems.find(item => item.article_version !== null && item.article_version.id === eventArticleVersionId);
      if (!tarIdtfItem) return;
      // 批次更新屬性，減少重複賦值
      const updates = {};
      if (ll_comment !== undefined) updates.ll_comment = ll_comment;
      if (effects !== undefined) updates.effects = effects;
      if (remarkValue !== undefined) updates[remarkKey] = remarkValue;
      if (checkedValue !== undefined) {
        if (isCheckedValueSame) {
          updates[subModelName] = null;
          updates[remarkKey] = null;
        } else {
          updates[subModelName] = `${checkedValue}`;
          if (checkedValue === '1') {
            updates[remarkKey] = null;
          }
        }
      }
      // 一次性更新所有屬性
      Object.assign(tarIdtfItem, updates);
    };
  },
  setVersionKeys(subModelName) {
    const baseVersionKeys = ['act_version', 'article_version'];
    const extendedVersionKeys = [
      'audit_template_version',
      'checklist_template_version',
      'contractor_license_template_version',
      'internal_training_template_version',
      'license_template_version',
    ];
    const extendedSubModelNames = [
      'idtf_check_result',
      'idtf_review_result',
      'overall_review_result'
    ];
    return extendedSubModelNames.includes(subModelName)
      ? [...baseVersionKeys, ...extendedVersionKeys]
      : baseVersionKeys;
  },
  setCreateIdtfData(actVersionId, rawData) {
    const { overall_owners, km_owners, km_backups, km_reviewers, idtf_owners, idtf_backups, idtf_reviewers, is_released_after_content_review, is_need_lawyer_idtf } = rawData;
    const baseData = {
      act_version: actVersionId,
      has_idtf: is_need_lawyer_idtf,
      has_released_first: is_released_after_content_review,
      km_owners,
      km_backups,
      km_reviewers,
    };
    return is_need_lawyer_idtf
      ? {
        ...baseData,
        idtf_owners,
        idtf_backups,
        idtf_reviewers,
        overall_owners,
      }
      : baseData;
  },
  isAssignmentDraft(idtfData) {
    return idtfData.act_idtf_assignment.status === 1;
  },
  isUserOwner(idtfData, stageName) {
    if (!idtfData || !stageName) return false;
    const ownerList = {
      act_cnt_update: ['km_owners', 'km_backups'],
      act_cnt_review: ['km_reviewers', 'km_backups'],
      idtf_update: ['idtf_owners', 'idtf_backups'],
      idtf_review: ['idtf_reviewers', 'idtf_backups'],
      idtf_review_overall: ['overall_owners'],
    };
    const ownerKeys = ownerList[stageName];
    if (!ownerKeys) return false;
    const currentUserId = store.state.user.currentUser.id;
    return ownerKeys.some(key => {
      const ownerArray = idtfData[key];
      return ownerArray && ownerArray.length && ownerArray.some(owner => owner.id === currentUserId);
    });
  },
  setReviewBtnTitle(idtfData, stageName) {
    const titleList = {
      act_cnt_update: {requiredValue: 1, requiredField: 'act_cnt_status', title: '更新法規格式內容'},
      act_cnt_review: {requiredValue: 2, requiredField: 'act_cnt_status', title: '覆核法規格式內容'},
      idtf_update: {requiredValue: 1, requiredField: 'idtf_status', title: '鑑別法規'},
      idtf_review: {requiredValue: 2, requiredField: 'idtf_status', title: '覆核鑑別法規'},
      idtf_review_overall: {requiredValue: 1, requiredField: 'overall_review_status', title: '總覆核鑑別法規'},
    };
    const config = titleList[stageName];
    return config && idtfData[config.requiredField] === config.requiredValue
      ? config.title
      : '';
  },
  setReadPageTopCustomBtns(idtfData, stageName) {
    if (!idtfData || !stageName) return [];
    const btnList = [{
      title: '查看相關連動公版',
      color: 'textSecondary',
      outlined: true,
      icon: 'mdi-view-dashboard',
      emit: 'go-to-related-template',
    }];
    if (
      !idtfData.act_idtf_assignment ||
      !this.isUserOwner(idtfData, stageName) ||
      this.isAssignmentDraft(idtfData)
    ) return btnList;
    const reviewBtnTitle = this.setReviewBtnTitle(idtfData, stageName);
    if (reviewBtnTitle) {
      btnList.push({
        title: reviewBtnTitle,
        icon: 'mdi-checkbox-marked-circle',
        emit: 'goToReview',
      });
    }
    const isStageFinished = this.isStageFinished(idtfData, stageName);
    if (stageName === 'act_cnt_update' || stageName === 'act_cnt_review') {
      btnList.push({
        tooltip: `刪除`,
        icon: 'mdi-delete',
        emit: 'delete-article',
        checkDisplayOnModelData: () => false,
        isDisplay: !isStageFinished,
      })
    }
    if (!isStageFinished && (stageName === 'idtf_update' || stageName === 'idtf_review')) {
      btnList.unshift({
        title: '編輯鑑別人員',
        color: 'textSecondary',
        outlined: true,
        icon: 'mdi-pencil',
        emit: 'edit-idtf-owners',
      });
    }
    return btnList;
  }
}
